import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Menu } from "antd";
import moment from "moment";

import CommissionApi from "../../../apis/Commission.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import SellerCase from "./seller/SellerCase";
import SellerMonth from "./seller/SellerMonth";
import SellerSearch from "./seller/SellerSearch";

const SellerComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [influencerMonth, setInfluencerMonth] = useState([
    // {
    // 	settlement_month: moment().subtract(1, "month"),
    // 	settlement_complete_date: null,
    // 	expected_payment_amount: null,
    // 	total_purchase_amount: null,
    // 	profit_amount: null,
    // 	settlement_status: null,
    // },
  ]);
  // const [influencerList, setInfluencerList] = useState([]);
  // const [optionList, setOptionList] = useState([]);
  const [selectInfluencer, setSelectInfluencer] = useState({
    id: 0,
    brand_name: "",
  });
  const [searchOption, setSearchOption] = useState({
    name: null,
  });
  const [orderTotalList, setOrderTotalList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [navType, setNavType] = useState("month");
  const [targetYear, setTargetYear] = useState(
    moment().subtract(1, "month").format("YYYY"),
  );
  const [targetMonth, setTargetMonth] = useState(
    moment().subtract(1, "month").format("MM"),
  );
  const [summary, setSummary] = useState({
    complete_num: 0,
    total: 0, // 1. 판매 금액 : 매출액
    commission: 0, // 2. 수익금액 : 매출액 * 커미션율
    // tax: 0, // 3. 세금 : 수익금액 * 0.967(-3.3%) / 수익금액 * 1.1(+10%) (개인/법인)
    profit: 0, //  4. 정산 금액 : 수익 금액 - 세금
  });

  const [queryListStr, setQueryListStr] = useState([]);
  // const [commissionList, setCommissionList] = useState([]);
  const [totalSizeMonth, setTotalSizeMonth] = useState(0);
  const [pageSizeMonth, setPageSizeMonth] = useState(10);
  const [offsetMonth, setOffsetMonth] = useState(0);
  const [currentPageNumberMonth, setCurrentPageNumberMonth] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  // useEffect(() => {
  // 	getInfluencerList();
  // }, []);

  useEffect(() => {
    // eslint-disable-next-line no-prototype-builtins
    if (selectInfluencer?.hasOwnProperty("id")) {
      getCommissionData(targetYear, targetMonth, "search");
      if (pageSizeMonth !== 10) {
        setPageSizeMonth(10);
      }
      if (offsetMonth !== 0) {
        setOffsetMonth(0);
      }
      if (currentPageNumberMonth !== 1) {
        setCurrentPageNumberMonth(1);
      }
      // if (pageSize !== 10) {
      // 	setPageSize(10);
      // }
      // if (offset !== 0) {
      // 	setOffset(0);
      // }
      // if (currentPageNumber !== 1) {
      // 	setCurrentPageNumber(1);
      // }
    }
  }, [targetYear, targetMonth]);
  // }, [selectInfluencer, targetYear, targetMonth]);

  useEffect(() => {
    getCommissionData(targetYear, targetMonth);
  }, [pageSizeMonth, currentPageNumberMonth]);

  // useEffect(() => {
  // 	getCommissionData(targetYear, targetMonth);
  // }, [pageSize, currentPageNumber]);

  // const getInfluencerList = async () => {
  // 	const res = await CommissionApi.readInfluencerList();
  // 	if (res.code === 200) {
  // 		let list = res.result?.filter(
  // 			(item) => item.role === "level_1" && item.id !== 9
  // 		);
  // 		setInfluencerList(list);
  // 		// setSelectInfluencer(list[0]);
  // 		setOptionList([
  // 			// eslint-disable-next-line no-unsafe-optional-chaining
  // 			...list?.map((item) => ({
  // 				value: item.id,
  // 				label: item.nickname,
  // 			})),
  // 		]);
  // 	}
  // };

  /**
   * 셀러에 해당하는 쿼리리스트 가져오기
   * @returns {Promise<void>}
   */
  // const getQueryList = useCallback(
  // 	async (selectYear, selectMonth) => {
  // 		setIsLoading(true);
  // 		let param = {
  // 			userId: selectInfluencer?.id,
  // 		};
  // 		const res = await CommissionApi.readQueryList(param);
  // 		if (res.code === 200) {
  // 			let list = res.result;
  // 			let queryList = [];
  // 			for (let i = 0; i < list?.length; i++) {
  // 				if (list[i].query) {
  // 					queryList.push(list[i].query);
  // 				}
  // 			}
  // 			setQueryListStr(queryList.toString() ?? "");
  // 			getCommissionData(queryList.toString() ?? "", selectYear, selectMonth);
  // 		} else {
  // 			setIsLoading(false);
  // 		}
  // 	},
  // 	[selectInfluencer]
  // );

  /**
   * 셀러 월별 데이터 가져오기
   * @returns {Promise<void>}
   */
  // const getInfluencerYear = async () => {
  //     let param = {
  //         userId: selectInfluencer?.id,
  //         searchYear: targetYear,
  //         super_admin: (user?.role === "super_admin")
  //     }
  //     const res = await CommissionApi.readBrandYear(param);
  //     if (res.code === 200) {
  //         setInfluencerMonth(res.result);
  //     }
  // }

  /**
   * 정산 내역 가져오기
   * @returns {Promise<void>}
   */
  const getCommissionData = async (selectYear, selectMonth, type = "") => {
    setIsLoading(true);
    let param = {
      offset: offsetMonth,
      pageSize: pageSizeMonth,
      startDate: moment(
        `${selectYear ? selectYear : targetYear}-${
          selectMonth ? selectMonth : targetMonth
        }`,
      )
        .startOf("month")
        .format("YYYYMMDDHHmm"),
      endDate: moment(
        `${selectYear ? selectYear : targetYear}-${
          selectMonth ? selectMonth : targetMonth
        }`,
      )
        .endOf("month")
        .format("YYYYMMDDHHmm"),
      searchName: searchOption.name,
      settlementType: "month",
      orderType: "name",
      orderBy: "asc",
    };
    if (type === "reset") {
      param = {
        ...param,
        offset: 0,
        pageSize: 10,
        searchName: null,
      };
    } else if (type === "search") {
      param = {
        ...param,
        offset: 0,
        pageSize: 10,
      };
    }
    console.log("getCommissionData :: param = ", param);
    const res = await CommissionApi.readSellerCommission(param);
    if (res.code === 200) {
      // let orderDetailList = res.result?.userOrderDetailDTOList;
      // let total = 0;
      // let profit = 0; // 수익
      // let tax = 0; // 세금
      // const list = orderDetailList?.filter(
      // 	(item) => item.order_detail_status === "complete"
      // );
      // let commission = Math.round(
      // 	profit * (orderDetailList[0]?.vat ? 1.1 : 0.967)
      // ); // 정산금액
      // setTotalSize(list?.length);
      // setOrderTotalList(list);
      // setOrderList(list?.slice(offset ?? 0, offset + pageSize ?? 10));
      // setSummary({
      // 	complete_num: rsq.result?.purchases_complete_num ?? 0,
      // 	total: rsq.result?.combined_amount ?? 0,
      // 	commission:
      // 		Math.round(
      // 			rsq.result?.profit_amount *
      // 				(orderDetailList[0]?.vat ? 1.0 : 0.967)
      // 		) ?? 0,
      // 	profit: rsq.result?.profit_amount ?? 0,
      // });
      setTotalSizeMonth(res.result?.totalCnt);
      setInfluencerMonth(
        res.result?.partnersSettlementList?.length
          ? res.result?.partnersSettlementList
          : [
              // {
              // 	settlement_month: moment(
              // 		`${selectYear ? selectYear : targetYear}-${
              // 			selectMonth ? selectMonth : targetMonth
              // 		}`
              // 	).startOf("month"),
              // 	settlement_complete_date: null,
              // 	expected_payment_amount: null,
              // 	total_purchase_amount: null,
              // 	profit_amount: null,
              // 	settlement_status: null,
              // },
            ],
      );
      // setInfluencerMonth([]);
      setIsLoading(false);
    } else {
      setOrderList([]);
      setSummary({
        complete_num: 0,
        total: 0,
        commission: 0,
        profit: 0,
      });
      setInfluencerMonth([
        // {
        // 	settlement_month: moment(
        // 		`${selectYear ? selectYear : targetYear}-${
        // 			selectMonth ? selectMonth : targetMonth
        // 		}`
        // 	).startOf("month"),
        // 	settlement_complete_date: null,
        // 	expected_payment_amount: null,
        // 	total_purchase_amount: null,
        // 	profit_amount: null,
        // 	settlement_status: null,
        // },
      ]);
      setIsLoading(false);
    }
  };
  // const getCommissionData = useCallback(
  // 	async (selectYear, selectMonth) => {
  // 		console.log("getCommissionData :: searchOption = ", searchOption);
  // 		let param = {
  // 			offset: offsetMonth,
  // 			pageSize: pageSizeMonth,
  // 			startDate: moment(
  // 				`${selectYear ? selectYear : targetYear}-${
  // 					selectMonth ? selectMonth : targetMonth
  // 				}`
  // 			)
  // 				.startOf("month")
  // 				.format("YYYYMMDDHHmm"),
  // 			endDate: moment(
  // 				`${selectYear ? selectYear : targetYear}-${
  // 					selectMonth ? selectMonth : targetMonth
  // 				}`
  // 			)
  // 				.endOf("month")
  // 				.format("YYYYMMDDHHmm"),
  // 			searchName: searchOption.name,
  // 			settlementType: "month",
  // 			orderType: "name",
  // 			orderBy: "asc",
  // 		};
  //
  // 		console.log("getCommissionData :: param = ", param);
  // 		const res = await CommissionApi.readSellerCommission(param);
  // 		if (res.code === 200) {
  // 			// let orderDetailList = res.result?.userOrderDetailDTOList;
  // 			// let total = 0;
  // 			// let profit = 0; // 수익
  // 			// let tax = 0; // 세금
  // 			// const list = orderDetailList?.filter(
  // 			// 	(item) => item.order_detail_status === "complete"
  // 			// );
  // 			// let commission = Math.round(
  // 			// 	profit * (orderDetailList[0]?.vat ? 1.1 : 0.967)
  // 			// ); // 정산금액
  // 			// setTotalSize(list?.length);
  // 			// setOrderTotalList(list);
  // 			// setOrderList(list?.slice(offset ?? 0, offset + pageSize ?? 10));
  // 			// setSummary({
  // 			// 	complete_num: rsq.result?.purchases_complete_num ?? 0,
  // 			// 	total: rsq.result?.combined_amount ?? 0,
  // 			// 	commission:
  // 			// 		Math.round(
  // 			// 			rsq.result?.profit_amount *
  // 			// 				(orderDetailList[0]?.vat ? 1.0 : 0.967)
  // 			// 		) ?? 0,
  // 			// 	profit: rsq.result?.profit_amount ?? 0,
  // 			// });
  // 			setTotalSizeMonth(res.result?.totalCnt);
  // 			setInfluencerMonth(
  // 				res.result?.partnersSettlementList?.length
  // 					? res.result?.partnersSettlementList
  // 					: [
  // 							// {
  // 							// 	settlement_month: moment(
  // 							// 		`${selectYear ? selectYear : targetYear}-${
  // 							// 			selectMonth ? selectMonth : targetMonth
  // 							// 		}`
  // 							// 	).startOf("month"),
  // 							// 	settlement_complete_date: null,
  // 							// 	expected_payment_amount: null,
  // 							// 	total_purchase_amount: null,
  // 							// 	profit_amount: null,
  // 							// 	settlement_status: null,
  // 							// },
  // 					  ]
  // 			);
  // 			// setInfluencerMonth([]);
  // 			setIsLoading(false);
  // 		} else {
  // 			setOrderList([]);
  // 			setSummary({
  // 				complete_num: 0,
  // 				total: 0,
  // 				commission: 0,
  // 				profit: 0,
  // 			});
  // 			setInfluencerMonth([
  // 				// {
  // 				// 	settlement_month: moment(
  // 				// 		`${selectYear ? selectYear : targetYear}-${
  // 				// 			selectMonth ? selectMonth : targetMonth
  // 				// 		}`
  // 				// 	).startOf("month"),
  // 				// 	settlement_complete_date: null,
  // 				// 	expected_payment_amount: null,
  // 				// 	total_purchase_amount: null,
  // 				// 	profit_amount: null,
  // 				// 	settlement_status: null,
  // 				// },
  // 			]);
  // 			setIsLoading(false);
  // 		}
  // 	},
  // 	[queryListStr, selectInfluencer]
  // );

  // const getCommissionPage = async () => {
  // 	setIsLoading(true);
  // 	// let param = {
  // 	//     queryList: queryString,
  // 	//     startDate: moment(`${targetYear}.${targetMonth}`).startOf("month").format("YYYYMMDDHHmm"),
  // 	//     endDate: moment(`${targetYear}.${targetMonth}`).endOf("month").format("YYYYMMDDHHmm"),
  // 	//     orderType: "payment_created_at",
  // 	//     orderBy: "desc",
  // 	// };
  // 	//
  // 	// const res = await CommissionApi.readInfluencerCommission(param);
  // 	// if (res.code === 200) {
  // 	//     let orderDetailList = res.result?.userOrderDetailDTOList;
  // 	//     const list = orderDetailList.filter((item) => item.order_detail_status === "complete");
  // 	//     setTotalSize(list?.length);
  // 	//     setOrderList(list.slice(offset, offset + pageSize))
  // 	// }
  // 	setOrderList(orderTotalList.slice(offset, offset + pageSize));
  // 	setIsLoading(false);
  // };

  return (
    <>
      <ContentHeaderComponent title="셀러 마감" />
      <Menu
        className={`commission-nav`}
        mode="horizontal"
        defaultSelectedKeys={["month"]}
        selectedKeys={[navType]}
      >
        <Menu.Item key={`month`} onClick={() => setNavType("month")}>
          월별 정산내역
        </Menu.Item>
        {/*<Menu.Item key={`case`} onClick={() => setNavType("case")}>*/}
        {/*	건별 정산내역*/}
        {/*</Menu.Item>*/}
      </Menu>
      <div className="product-register-wrap">
        <div className={`commission-information`}>
          <div className={`commission-information-each`}>
            <p className={`title`}>정산정보</p>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/account.png`}
                alt={"정산방식"}
              />
              <div className="text-div">
                <p>정산방식</p>
                <p style={{ fontWeight: 500 }}>계좌이체</p>
              </div>
            </div>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/month.png`}
                alt={"정산주기"}
              />
              <div className="text-div">
                <p>정산주기</p>
                <p style={{ fontWeight: 500 }}>월 정산</p>
              </div>
            </div>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/date.png`}
                alt={"정산예정"}
              />
              <div className="text-div">
                <p>정산예정</p>
                <p style={{ fontWeight: 500 }}>정산기준일 +1 영업일</p>
              </div>
            </div>
          </div>
          <div className={`commission-information-each`}>
            <p className={`title`}>수수료정보</p>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/fee.png`}
                alt={"당영관리수수료"}
              />
              <div className="text-div">
                <p>당영 관리 수수료</p>
                <p style={{ fontWeight: 500 }}>
                  11% <span>(VAT포함)</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <SellerSearch
          searchOption={searchOption}
          setSearchOption={setSearchOption}
          targetYear={targetYear}
          targetMonth={targetMonth}
          getCommissionData={getCommissionData}
          pageSize={pageSizeMonth}
          setPageSize={setPageSizeMonth}
          offset={offsetMonth}
          setOffset={setOffsetMonth}
          currentPageNumber={currentPageNumberMonth}
          setCurrentPageNumber={setCurrentPageNumberMonth}
        />

        {navType === "month" ? (
          <SellerMonth
            targetYear={targetYear}
            setTargetYear={setTargetYear}
            targetMonth={targetMonth}
            setTargetMonth={setTargetMonth}
            setNavType={setNavType}
            summary={summary}
            selectInfluencer={selectInfluencer}
            influencerMonth={influencerMonth}
            // getQueryList={getQueryList}
            totalSize={totalSizeMonth}
            pageSize={pageSizeMonth}
            setPageSize={setPageSizeMonth}
            setOffset={setOffsetMonth}
            currentPageNumber={currentPageNumberMonth}
            setCurrentPageNumber={setCurrentPageNumberMonth}
          />
        ) : (
          <SellerCase
            targetYear={targetYear}
            setTargetYear={setTargetYear}
            targetMonth={targetMonth}
            setTargetMonth={setTargetMonth}
            orderList={orderList}
            summary={summary}
            selectInfluencer={selectInfluencer}
            totalSize={totalSize}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setOffset={setOffset}
            currentPageNumber={currentPageNumber}
            setCurrentPageNumber={setCurrentPageNumber}
          />
        )}
      </div>
    </>
  );
};
export default SellerComponent;
